import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Link } from 'react-router-dom';
import collegeImage from 'LOGIN/Components/LoginPage/images/vm-dummy-banner.png';
import { Base64 } from 'js-base64';
import ReactHtmlParser from 'react-html-parser';
import 'LOGIN/Components/LoginPage/loginpage.css';
import axios from 'axios';
import Spinner from 'LOGIN/CommonResources/SpinnerLoader/Spinner';
import { useState, useEffect } from 'react';
import LoginAPICall from 'LoginAPICall';
import GoogleLogin from 'react-google-login';
import OTPInput from 'react-otp-input';

const CLIENT_ID = "1051565806657-s1an6r32ecti5o4ogrp2q1uhhpkgjffk.apps.googleusercontent.com";

class LoginPage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            instituteUrl: this.props.match.params.instituteUrl,
            instituteName: '',
            instituteLogo: '',
            instituteImage: '',
            instituteId: '',
            instituteDetailsFetching: false,
            isValidURL: '',
            userName: '',
            userNameWarning: '',
            password: '',
            passwordWarning: '',
            responseMessage: '',
            loggedIn: false,
            accountType: '',
            isSameCollege: '',
            OTPVerification: false,
            facultyEmail: '',
            OTPUniqueId: '',
            userEnteredOTP: '',
            isOTPValid: false,
            OTPWarning: '',
            obscureEmail: '',
            invalidOTPWarning: '',
            resendOTP: false,
            seconds: 30,
            sendingOTP: false,

            // google mail login states
            userEmail: ''
        };
    }

    componentDidMount() {

        // METHOD CALLED TO GET INSTITUTE DETAILS
        this.apiCallToGetInstituteDetails();

        var cookies = decodeURIComponent(document.cookie);
        let userInfo = cookies.split(';');
        var cookieData = new Map();
        for(let i = 0; i < userInfo.length; i++) {
            let key = userInfo[i].split("=")[0].trim();
            let value = userInfo[i].split("=")[1];
            cookieData.set(key, value);
        }
        if(cookieData.has('user_details') && cookieData.has('user_token') && cookieData.has('sync_token')){
            this.setState({
                loggedIn: true
            });
            let userDetails = cookieData.get('user_details');

            let decodedUserDetails = JSON.parse(Base64.decode(Base64.decode(userDetails)));

            this.setState({
                accountType: decodedUserDetails.data.account
            });
        }else {
            this.setState({
                loggedIn: false
            });
        }
    }

    // Success Handler
    responseGoogleSuccess = (response) => {
       
        this.setState({ 
            userEmail: response.profileObj.email,
        });

        this.apiCallToLoginUsingGoogleEmail();
    };

    // API CALL METHOD TO LOGIN TO PORTAL USING GOOGLE EMAIL
    apiCallToLoginUsingGoogleEmail = async () => {

        let formData = new FormData();
        let userData = {
            "user_email": this.state.userEmail,
            'institute_id': this.state.instituteId
        };

        formData.append("logInUsingGoogleEmail", true);
        formData.append("data", Base64.encode(JSON.stringify(userData)));

        axios({
            method: "post",
            url: (window.location.origin == 'http://localhost:3000' ? 'https://stage.vmedulife.com' : window.location.origin)  + "/api/generic_api.php",
            data: formData,
        }).then((response) => {
            let jsonResponse = response.data;
            if(jsonResponse.success == 'true') {
                function setCookie(name,value) {
                    document.cookie = name + "=" + (value || "") + "; path=/";
                }
                if(jsonResponse.account == 'faculty') {
                    let userDetails = {};
                    if(userDetails.data == undefined) {
                        userDetails.data = {};
                    }

                    userDetails.data.account = jsonResponse.account;
                    userDetails.data.user_id = jsonResponse.user;
                    userDetails.data.AcaYear = jsonResponse.facultyData.AcaYear;
                    userDetails.data.AcaYearId = jsonResponse.facultyData.AcaYearId;
                    userDetails.data.DOB = jsonResponse.facultyData.DOB;
                    userDetails.data.EmailId = jsonResponse.facultyData.EmailId;
                    userDetails.data.FirstName = jsonResponse.facultyData.FirstName;
                    userDetails.data.InstitudeId = jsonResponse.facultyData.InstitudeId;
                    userDetails.data.InstituteLogo = jsonResponse.facultyData.InstituteLogo;
                    userDetails.data.InstituteName = jsonResponse.facultyData.InstituteName;
                    userDetails.data.InstituteShortName = jsonResponse.facultyData.InstituteShortName;
                    userDetails.data.InstituteUrl = jsonResponse.facultyData.InstituteUrl;
                    userDetails.data.Institute_iid = jsonResponse.facultyData.Institute_iid;
                    userDetails.data.LastName = jsonResponse.facultyData.LastName;
                    userDetails.data.MobileNumber = jsonResponse.facultyData.MobileNumber;
                    userDetails.data.StreamId = jsonResponse.facultyData.StreamId;
                    userDetails.data.StreamName = jsonResponse.facultyData.StreamName;
                    userDetails.data.UserDp = jsonResponse.facultyData.UserDp;
                    userDetails.data.Points = jsonResponse.facultyData.Points;
                    userDetails.data.uid = jsonResponse.facultyData.uid;
                    userDetails.role = jsonResponse.facultyData.facultyRole;
                    userDetails.success = 'true';

                    let encodedUserDetails = Base64.encode(Base64.encode(JSON.stringify(userDetails)));
                    let encodedAcademicYear = Base64.encode(Base64.encode(JSON.stringify(jsonResponse.AcademicYearList)));
                    let encodedStreamList = Base64.encode(Base64.encode(JSON.stringify(jsonResponse.facultyData.Stream)));
                    setCookie('acyear', encodedAcademicYear);
                    setCookie('user_token', jsonResponse.tokenDetails.data.user_token);
                    setCookie('sync_token', jsonResponse.tokenDetails.data.sync_token);
                    setCookie('userStreamList', encodedStreamList);
                    setCookie('user_details', encodedUserDetails);

                    if(jsonResponse.facultyData.MobileNumber != '' && jsonResponse.facultyData.DOB != '' && jsonResponse.facultyData.EmailId != '') {
                        window.location.href = (window.location.origin == 'http://localhost:3000' ? 'https://stage.vmedulife.com' : window.location.origin) + '/modules/summary/#/';
                    }else {
                        window.location.href = (window.location.origin == 'http://localhost:3000' ? 'https://stage.vmedulife.com' : window.location.origin) + '/userMobileEmailValidation.php';
                    }
                }else {
                    let userDetails = {};
                    if(userDetails.data == undefined) {
                        userDetails.data = {};
                    }

                    userDetails.data.account = jsonResponse.account;
                    userDetails.data.user_id = jsonResponse.user;
                    userDetails.data.Acayear = jsonResponse.studentData.Acayear;
                    userDetails.data.admissionYear = jsonResponse.studentData.admissionYear;
                    userDetails.data.DOB = jsonResponse.studentData.DOB;
                    userDetails.data.EmailId = jsonResponse.studentData.EmailId;
                    userDetails.data.FirstName = jsonResponse.studentData.FirstName;
                    userDetails.data.InstitudeId = jsonResponse.studentData.InstitudeId;
                    userDetails.data.InstituteLogo = jsonResponse.studentData.InstituteLogo;
                    userDetails.data.InstituteName = jsonResponse.studentData.InstituteName;
                    userDetails.data.InstituteShortName = jsonResponse.studentData.InstituteShortName;
                    userDetails.data.InstituteUrl = jsonResponse.studentData.InstituteUrl;
                    userDetails.data.LastName = jsonResponse.studentData.LastName;
                    userDetails.data.MobileNumber = jsonResponse.studentData.MobileNumber;
                    userDetails.data.PRNno = jsonResponse.studentData.PRNno;
                    userDetails.data.PlStream = jsonResponse.studentData.PlStream;
                    userDetails.data.Points = jsonResponse.studentData.Points;
                    userDetails.data.UserDp = jsonResponse.studentData.UserDp;
                    userDetails.data.stuid = jsonResponse.studentData.stuid;
                    userDetails.role = 'learner';
                    userDetails.success = 'true';

                    let encodedUserDetails = Base64.encode(Base64.encode(JSON.stringify(userDetails)));
                    let encodedAcademicYear = Base64.encode(Base64.encode(JSON.stringify(jsonResponse.AcademicYearList)));
                    let encodedElectiveBatches = Base64.encode(JSON.stringify(jsonResponse.studentData.electiveBatches.data));
                    let encodedGroupDetails = Base64.encode(JSON.stringify(jsonResponse.studentData.groupDetailsArray));
                    let encodedAssignedBatches = Base64.encode(JSON.stringify(jsonResponse.studentData.studentAssignedBatches));
                    setCookie('acyear', encodedAcademicYear);
                    setCookie('user_token', jsonResponse.tokenDetails.data.user_token);
                    setCookie('sync_token', jsonResponse.tokenDetails.data.sync_token);
                    setCookie('user_details', encodedUserDetails);
                    setCookie('learner_studentAssignedBatches', encodedAssignedBatches);
                    setCookie('learner_groupDetailsArray', encodedGroupDetails);
                    setCookie('learner_studentAssignedElectiveBatches', encodedElectiveBatches);

                    if(jsonResponse.studentData.MobileNumber != '' && jsonResponse.studentData.DOB != '' && jsonResponse.studentData.EmailId != '') {
                        window.location.href = (window.location.origin == 'http://localhost:3000' ? 'https://stage.vmedulife.com' : window.location.origin) + '/student/Summary.php';
                    }else {
                        window.location.href = (window.location.origin == 'http://localhost:3000' ? 'https://stage.vmedulife.com' : window.location.origin) + '/userMobileEmailValidation.php';
                    }
                }
            }else {
                this.setState({
                    responseMessage: jsonResponse.message
                });
            }
        }).catch(error => {
            console.log(error);
        });
    }

    // Error Handler
    responseGoogleError = (response) => {
        alert("Failed to validate.");
    };

    // METHOD TO VIEW PASSWORD
    viewPassword = () => {
        let passwordText = document.getElementById('passwordValue');
        passwordText.type = 'text';
    }

    // METHOD TO HIDE PASSWORD
    hidePassword = () => {
        let passwordText = document.getElementById('passwordValue');
        passwordText.type = 'password';
    }

    // METHOD TO GET INSTITUTE DETAILS FROM INSTITUTE URL
    apiCallToGetInstituteDetails = async () => {
        this.setState({
            instituteDetailsFetching: true
        });

        let requestData = {
            "url": this.props.match.params.instituteUrl,
        };

        let jsonResponse = await LoginAPICall.makeAPICall(
            'getInstituteDataByURL',
            requestData,
            '/api/generic_api.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetInstituteDetails();
            }, 1000);
        } else {
            let apiResult = jsonResponse.APIResult.data;
            if(jsonResponse.APIResult.success == 'true' && Object.keys(apiResult).length > 0) {
                var cookies = decodeURIComponent(document.cookie);
                let userInfo = cookies.split(';');
                var cookieData = new Map();
                for(let i = 0; i < userInfo.length; i++) {
                    let key = userInfo[i].split("=")[0].trim();
                    let value = userInfo[i].split("=")[1];
                    cookieData.set(key, value);
                }
                if(cookieData.has('user_details') && cookieData.has('user_token') && cookieData.has('sync_token')){
                    let userDetails = cookieData.get('user_details');

                    let decodedUserDetails = JSON.parse(Base64.decode(Base64.decode(userDetails)));
                    if(apiResult.InstituteId == decodedUserDetails.data.InstitudeId) {
                        this.setState({
                            isSameCollege: true
                        });
                    }else {
                        this.setState({
                            isSameCollege: false
                        });
                    }
                }
                this.setState({
                    instituteName: apiResult.InstituteName,
                    instituteLogo: apiResult.InstituteLogo,
                    instituteImage: apiResult.InstituteBannerImage,
                    instituteId: apiResult.InstituteId,
                    isValidURL: true,
                    instituteDetailsFetching: false
                });
            }else {
                this.setState({
                    isValidURL: false,
                    instituteDetailsFetching: false
                });
            }
        }
    }

    // METHOD TO GET USER NAME
    getUserName = (e) => {
        this.setState({
            userName: e.target.value
        });

        if(e.target.value.length < 1) {
            this.setState({
                userNameWarning: 'Username cannot be empty.'
            });
        }else {
            this.setState({
                userNameWarning: ''
            });
        }
    }

    // METHOD TO GET PASSWORD
    getPassword = (e) => {
        this.setState({
            password: e.target.value
        });

        if(e.keyCode == 13 || e.which == 13)
        {
            this.validateLoginData();
        }

        if(e.target.value.length < 1) {
            this.setState({
                passwordWarning: 'Password cannot be empty.'
            });
        }else {
            this.setState({
                passwordWarning: ''
            });
        }
    }

    //METHOD TO START THE TIMER
    startTimer = () => {
        let seconds = this.state.seconds;

        if(seconds > 0)
        {
            setTimeout(this.countDown, 1000);
        }

        if(seconds > 30)
        {
            seconds = 30;
        }

        this.setState({
            seconds
        });
    }

    //METHOD TO COUNT SECONDS
    countDown = () => {
        let seconds = this.state.seconds;

        seconds = seconds - 1;

        if(seconds > -1)
        {
            this.setState({
                seconds
            },
            () => {
                if(seconds != 0)
                {
                    this.startTimer();
                }
            });
        }
        
        // Check if we're at zero.
        if (seconds == 0) { 
            this.setState({
                resendOTP: true,
            });
        }
    }

    //METHOD TO SET FOCUS ON OTP FIELDS
    setOTPFieldFocus = (e,index) => {
        let inputs = document.getElementsByClassName("otp-inputs");

        if(index == 5 && (e.keyCode == 13 || e.which == 13))
        {
            this.validateOTPLogin();
        }

        //restricting focus change on non numeric keys
        if((e.keyCode >= 96 && e.keyCode <= 105) || (e.keyCode >= 48 && e.keyCode <= 57))
        {
            if(index != 5)
            {
                inputs[index + 1].focus();
            }
        }
    }

    //METHOD TO VALIDATE OTP FIELDS
    validateInput = (e) => {
        var regex = /[0-9]|\./;

        var key = '';

        if (e.type === 'paste') {
            key = e.clipboardData.getData('text/plain');
        } else {
            key = e.keyCode || e.which;
            key = String.fromCharCode(key);
        }

        if( !regex.test(key) ) {
            if(e.preventDefault) e.preventDefault();
        }
    }

    setOtpInput = (otp) => {
        this.setState({ userEnteredOTP: otp });
    };

    handleKeyPress = e => {
        if (e.key === 'Enter') {
          // Trigger OTP validation logic here
          this.validateOTPLogin();
        }
    };
    
    // METHOD TO VALIDATE LOGIN OTP DATA
    validateOTPLogin = () => {

        // this.setState({
        //     userEnteredOTP: ''
        // });
        let validData = true;

        let inputs = document.getElementsByClassName("otp-inputs");

        let userEnteredOTP = this.state.userEnteredOTP;

        // if(inputs.length > 0)
        // {
        //     Object.keys(inputs).map(otpInput => {
        //         userEnteredOTP += inputs[otpInput].value;
        //     })
        // }

        // this.setState({
        //     userEnteredOTP
        // });

        if(userEnteredOTP.length < 1 || userEnteredOTP.length < 6) {
            this.setState({
                OTPWarning: 'Please enter OTP.'
            });
            validData = false;
        }
        else
        {
            this.setState({
                OTPWarning: ''
            });
        }

        if(validData) {
            setTimeout(() => this.apiCallToVerifyOTP(),1000);
        }
    }

    // API CALL METHOD TO LOGIN TO PORTAL
    apiCallToVerifyOTP = async () => {
        this.setState({
            sendingOTP: true,
        });

        let formData = new FormData();
        let userData = {
            "uniqueId": this.state.OTPUniqueId,
            "userEnteredOtp": Base64.encode(this.state.userEnteredOTP),
            'emailId': this.state.facultyEmail,
            "institute_id": this.state.instituteId
        };

        formData.append("VerifyLoginOTP", true);
        formData.append("data", Base64.encode(JSON.stringify(userData)));

        axios({
            method: "post",
            url: (window.location.origin == 'http://localhost:3000' ? 'https://stage.vmedulife.com' : window.location.origin)  + "/api/generic_api.php",
            data: formData,
        }).then((response) => {
            let jsonResponse = response.data;
            
            if(jsonResponse.success == 'true' && jsonResponse.status == "success") {
               
                function setCookie(name,value) {
                    document.cookie = name + "=" + (value || "") + "; path=/";
                }
                if(jsonResponse.account == 'faculty') {
                    let userDetails = {};
                    if(userDetails.data == undefined) {
                        userDetails.data = {};
                    }

                    userDetails.data.account = jsonResponse.account;
                    userDetails.data.user_id = jsonResponse.user;
                    userDetails.data.AcaYear = jsonResponse.facultyData.AcaYear;
                    userDetails.data.AcaYearId = jsonResponse.facultyData.AcaYearId;
                    userDetails.data.DOB = jsonResponse.facultyData.DOB;
                    userDetails.data.EmailId = jsonResponse.facultyData.EmailId;
                    userDetails.data.FirstName = jsonResponse.facultyData.FirstName;
                    userDetails.data.InstitudeId = jsonResponse.facultyData.InstitudeId;
                    userDetails.data.InstituteLogo = jsonResponse.facultyData.InstituteLogo;
                    userDetails.data.InstituteName = jsonResponse.facultyData.InstituteName;
                    userDetails.data.InstituteShortName = jsonResponse.facultyData.InstituteShortName;
                    userDetails.data.InstituteUrl = jsonResponse.facultyData.InstituteUrl;
                    userDetails.data.Institute_iid = jsonResponse.facultyData.Institute_iid;
                    userDetails.data.LastName = jsonResponse.facultyData.LastName;
                    userDetails.data.MobileNumber = jsonResponse.facultyData.MobileNumber;
                    userDetails.data.StreamId = jsonResponse.facultyData.StreamId;
                    userDetails.data.StreamName = jsonResponse.facultyData.StreamName;
                    userDetails.data.UserDp = jsonResponse.facultyData.UserDp;
                    userDetails.data.Points = jsonResponse.facultyData.Points;
                    userDetails.data.uid = jsonResponse.facultyData.uid;
                    userDetails.role = jsonResponse.facultyData.facultyRole;
                    userDetails.success = 'true';

                    let encodedUserDetails = Base64.encode(Base64.encode(JSON.stringify(userDetails)));
                    let encodedAcademicYear = Base64.encode(Base64.encode(JSON.stringify(jsonResponse.AcademicYearList)));
                    let encodedStreamList = Base64.encode(Base64.encode(JSON.stringify(jsonResponse.facultyData.Stream)));
                    setCookie('acyear', encodedAcademicYear);
                    setCookie('user_token', jsonResponse.tokenDetails.data.user_token);
                    setCookie('sync_token', jsonResponse.tokenDetails.data.sync_token);
                    setCookie('userStreamList', encodedStreamList);
                    setCookie('user_details', encodedUserDetails);

                    if(jsonResponse.facultyData.MobileNumber != '' && jsonResponse.facultyData.DOB != '' && jsonResponse.facultyData.EmailId != '') {
                        window.location.href = (window.location.origin == 'http://localhost:3000' ? 'https://stage.vmedulife.com' : window.location.origin) + '/modules/summary/#/';
                    }else {
                        window.location.href = (window.location.origin == 'http://localhost:3000' ? 'https://stage.vmedulife.com' : window.location.origin) + '/userMobileEmailValidation.php';
                    }
                }
            }else {
                this.setState({
                    responseMessage: jsonResponse.message,
                    sendingOTP: false,
                });
            }
        }).catch(error => {
            console.log(error);
        });
    }

    // METHOD TO VALIDATE LOGIN DATA
    validateLoginData = () => {
        let validData = true;

        if(this.state.userName.length < 1) {
            this.setState({
                userNameWarning: 'Username cannot be empty.'
            });
            validData = false;
        }

        if(this.state.password.length < 1) {
            this.setState({
                passwordWarning: 'Password cannot be empty.'
            });
            validData = false;
        }

        if(validData) {
            this.apiCallToLoginToPortal();
        }
    }

    // API CALL METHOD TO LOGIN TO PORTAL
    apiCallToLoginToPortal = async () => {
        let OTPUniqueId = this.state.OTPUniqueId;
        let facultyEmail = this.state.facultyEmail;
        let obscureEmail = this.state.obscureEmail;
        let userName = this.state.userName;
        let password = this.state.password;

        this.setState({
            sendingOTP: true,
        });

        let formData = new FormData();
        let userData = {
            "username": this.state.userName,
            "password": this.state.password,
            'institute_id': this.state.instituteId
        };

        formData.append("verifyInstituteUserCredentials", true);
        formData.append("data", Base64.encode(JSON.stringify(userData)));

        axios({
            method: "post",
            url: (window.location.origin == 'http://localhost:3000' ? 'https://stage.vmedulife.com' : window.location.origin)  + "/api/generic_api.php",
            data: formData,
        }).then((response) => {
            let jsonResponse = response.data;
            if(jsonResponse.success == 'true') {
                function setCookie(name,value) {
                    document.cookie = name + "=" + (value || "") + "; path=/";
                }
                if(jsonResponse.account == 'faculty') {
                    let userDetails = {};
                    if(userDetails.data == undefined) {
                        userDetails.data = {};
                    }

                    OTPUniqueId = Base64.decode(jsonResponse.emailResponse.uniqueId);

                    facultyEmail = jsonResponse.facultyEmail;
                    let  otpSentToEmail = jsonResponse.otpSentTo;

                    let name = otpSentToEmail.split('@')[0];

                    obscureEmail = name[0]+new Array(name.length).join("*")+"@"+otpSentToEmail.split('@')[1];

                    this.setState({
                        sendingOTP: false,
                        OTPUniqueId,
                        facultyEmail,
                        OTPVerification: true,
                        obscureEmail,
                        userName,
                        password,
                        seconds: 30,
                    });

                    this.startTimer();

                    // userDetails.data.account = jsonResponse.account;
                    // userDetails.data.user_id = jsonResponse.user;
                    // userDetails.data.AcaYear = jsonResponse.facultyData.AcaYear;
                    // userDetails.data.AcaYearId = jsonResponse.facultyData.AcaYearId;
                    // userDetails.data.DOB = jsonResponse.facultyData.DOB;
                    // userDetails.data.EmailId = jsonResponse.facultyData.EmailId;
                    // userDetails.data.FirstName = jsonResponse.facultyData.FirstName;
                    // userDetails.data.InstitudeId = jsonResponse.facultyData.InstitudeId;
                    // userDetails.data.InstituteLogo = jsonResponse.facultyData.InstituteLogo;
                    // userDetails.data.InstituteName = jsonResponse.facultyData.InstituteName;
                    // userDetails.data.InstituteShortName = jsonResponse.facultyData.InstituteShortName;
                    // userDetails.data.InstituteUrl = jsonResponse.facultyData.InstituteUrl;
                    // userDetails.data.Institute_iid = jsonResponse.facultyData.Institute_iid;
                    // userDetails.data.LastName = jsonResponse.facultyData.LastName;
                    // userDetails.data.MobileNumber = jsonResponse.facultyData.MobileNumber;
                    // userDetails.data.StreamId = jsonResponse.facultyData.StreamId;
                    // userDetails.data.StreamName = jsonResponse.facultyData.StreamName;
                    // userDetails.data.UserDp = jsonResponse.facultyData.UserDp;
                    // userDetails.data.Points = jsonResponse.facultyData.Points;
                    // userDetails.data.uid = jsonResponse.facultyData.uid;
                    // userDetails.role = jsonResponse.facultyData.facultyRole;
                    // userDetails.success = 'true';

                    // let encodedUserDetails = Base64.encode(Base64.encode(JSON.stringify(userDetails)));
                    // let encodedAcademicYear = Base64.encode(Base64.encode(JSON.stringify(jsonResponse.AcademicYearList)));
                    // let encodedStreamList = Base64.encode(Base64.encode(JSON.stringify(jsonResponse.facultyData.Stream)));
                    // setCookie('acyear', encodedAcademicYear);
                    // setCookie('user_token', jsonResponse.tokenDetails.data.user_token);
                    // setCookie('sync_token', jsonResponse.tokenDetails.data.sync_token);
                    // setCookie('userStreamList', encodedStreamList);
                    // setCookie('user_details', encodedUserDetails);

                    // if(jsonResponse.facultyData.MobileNumber != '' && jsonResponse.facultyData.DOB != '' && jsonResponse.facultyData.EmailId != '') {
                    //     window.location.href = (window.location.origin == 'http://localhost:3000' ? 'https://stage.vmedulife.com' : window.location.origin) + '/modules/summary/#/';
                    // }else {
                    //     window.location.href = (window.location.origin == 'http://localhost:3000' ? 'https://stage.vmedulife.com' : window.location.origin) + '/userMobileEmailValidation.php';
                    // }
                }else {
                    let userDetails = {};
                    if(userDetails.data == undefined) {
                        userDetails.data = {};
                    }

                    userDetails.data.account = jsonResponse.account;
                    userDetails.data.user_id = jsonResponse.user;
                    userDetails.data.Acayear = jsonResponse.studentData.Acayear;
                    userDetails.data.admissionYear = jsonResponse.studentData.admissionYear;
                    userDetails.data.DOB = jsonResponse.studentData.DOB;
                    userDetails.data.EmailId = jsonResponse.studentData.EmailId;
                    userDetails.data.FirstName = jsonResponse.studentData.FirstName;
                    userDetails.data.InstitudeId = jsonResponse.studentData.InstitudeId;
                    userDetails.data.InstituteLogo = jsonResponse.studentData.InstituteLogo;
                    userDetails.data.InstituteName = jsonResponse.studentData.InstituteName;
                    userDetails.data.InstituteShortName = jsonResponse.studentData.InstituteShortName;
                    userDetails.data.InstituteUrl = jsonResponse.studentData.InstituteUrl;
                    userDetails.data.LastName = jsonResponse.studentData.LastName;
                    userDetails.data.MobileNumber = jsonResponse.studentData.MobileNumber;
                    userDetails.data.PRNno = jsonResponse.studentData.PRNno;
                    userDetails.data.PlStream = jsonResponse.studentData.PlStream;
                    userDetails.data.Points = jsonResponse.studentData.Points;
                    userDetails.data.UserDp = jsonResponse.studentData.UserDp;
                    userDetails.data.stuid = jsonResponse.studentData.stuid;
                    userDetails.role = 'learner';
                    userDetails.success = 'true';

                    let encodedUserDetails = Base64.encode(Base64.encode(JSON.stringify(userDetails)));
                    let encodedAcademicYear = Base64.encode(Base64.encode(JSON.stringify(jsonResponse.AcademicYearList)));
                    let encodedElectiveBatches = Base64.encode(JSON.stringify(jsonResponse.studentData.electiveBatches.data));
                    let encodedGroupDetails = Base64.encode(JSON.stringify(jsonResponse.studentData.groupDetailsArray));
                    let encodedAssignedBatches = Base64.encode(JSON.stringify(jsonResponse.studentData.studentAssignedBatches));
                    setCookie('acyear', encodedAcademicYear);
                    setCookie('user_token', jsonResponse.tokenDetails.data.user_token);
                    setCookie('sync_token', jsonResponse.tokenDetails.data.sync_token);
                    setCookie('user_details', encodedUserDetails);
                    setCookie('learner_studentAssignedBatches', encodedAssignedBatches);
                    setCookie('learner_groupDetailsArray', encodedGroupDetails);
                    setCookie('learner_studentAssignedElectiveBatches', encodedElectiveBatches);

                    if(jsonResponse.studentData.MobileNumber != '' && jsonResponse.studentData.DOB != '' && jsonResponse.studentData.EmailId != '') {
                        window.location.href = (window.location.origin == 'http://localhost:3000' ? 'https://stage.vmedulife.com' : window.location.origin) + '/student/Summary.php';
                    }else {
                        window.location.href = (window.location.origin == 'http://localhost:3000' ? 'https://stage.vmedulife.com' : window.location.origin) + '/userMobileEmailValidation.php';
                    }
                }
            }else {
                this.setState({
                    responseMessage: jsonResponse.message,
                    sendingOTP: false
                });
            }
        }).catch(error => {
            console.log(error);
        });
    }

    render() {
        let instituteImage = '';
        let instituteLogo = '';
        if(this.state.instituteImage != undefined) {
            let instituteImageExists = (/\.(gif|jpg|jpeg|tiff|png)$/i).test(this.state.instituteImage);
            if(instituteImageExists) {
                instituteImage = this.state.instituteImage;
            }else {
                instituteImage = collegeImage;
            }
        }
        if(this.state.instituteLogo != undefined) {
            let instituteLogoExists = (/\.(gif|jpg|jpeg|tiff|png|GIF|JPG|JPEG|TIFF|PNG)$/i).test(this.state.instituteLogo);
            if(instituteLogoExists) {
                instituteLogo = this.state.instituteLogo;
            }else {
                instituteLogo = collegeImage;
            }
        }
        return(
            <>
                {
                    this.state.instituteDetailsFetching ? 
                        <Spinner />
                    :
                    this.state.isValidURL ?
                        <div className="login-page">
                            <div className="login-container col-sm-5 col-md-4 col-lg-4">
                                {
                                    this.state.loggedIn ?
                                        <div className="login-form">
                                            <div className="institute-name">
                                                <div className="instituteLogo-image">
                                                    <img src={instituteLogo} className="instituteLogo-img" />
                                                </div>
                                                <div className="instituteName">
                                                    <h6>{ReactHtmlParser(this.state.instituteName)}</h6>
                                                </div>
                                            </div>
                                            {
                                                this.state.isSameCollege ?
                                                    <div className="access-account-button">
                                                        <button className="btn access-account" onClick={() => window.location.href = this.state.accountType == 'faculty' ? (window.location.origin == 'http://localhost:3000' ? 'https://stage.vmedulife.com' : window.location.origin) + '/modules/summary/#/' : (window.location.origin == 'http://localhost:3000' ? 'https://stage.vmedulife.com' : window.location.origin) + '/student/Summary.php'}>Access Account</button>
                                                    </div>
                                                :
                                                    <div className='no-same-college-message'>
                                                        <p>To access the account, please clear your browser history and try again.</p>
                                                    </div>
                                            }
                                        </div>
                                    :
                                        this.state.OTPVerification ?
                                            <div className="login-form">
                                                <div className="institute-name">
                                                    <div className="instituteLogo-image">
                                                        <img src={instituteLogo} className="instituteLogo-img" />
                                                    </div>
                                                    <div className="institute-name">
                                                        <h6>{ReactHtmlParser(this.state.instituteName)}</h6>
                                                    </div>
                                                    <div className="login-details mt-4">
                                                        <div className="col-md-12">
                                                            <span style={{ fontWeight:'bold' }}>
                                                                Enter One-Time Password(OTP)
                                                            </span>
                                                        </div>
                                                        <div className="col-md-12">
                                                            <span style={{ fontSize: '14px' }}>
                                                                OTP has been sent to your registered email address {this.state.obscureEmail}. Please enter the OTP below to proceed with login.
                                                            </span>
                                                        </div>
                                                        <div className="col-md-12 inputs d-flex flex-row mt-2">
                                                            <OTPInput
                                                                value={this.state.userEnteredOTP}
                                                                onChange={(e) => this.setOtpInput(e)}
                                                                numInputs={6}
                                                                renderSeparator={<span className='otp-separator'>-</span>}
                                                                renderInput={(props, index) => (
                                                                    <React.Fragment key={index}>
                                                                        <input
                                                                          {...props}
                                                                          className='col-md-2 otp-inputs'
                                                                          style={{
                                                                            marginRight: '10px',
                                                                            // width: '50px',
                                                                            // height: '50px',
                                                                            // fontSize: '20px',
                                                                            textAlign: 'center',
                                                                            borderRadius: '5px',
                                                                            border: '1px solid #ccc'
                                                                          }}
                                                                          onKeyDown={index == 5 ? this.handleKeyPress : null}
                                                                        />
                                                                        {(index !== 5) && this.props.separator}
                                                                    </React.Fragment>
                                                                  )}
                                                            />
                                                        </div>
                                                        {/* <div className="col-md-12 inputs d-flex flex-row mt-2" style={{ justifyContent:'space-between' }}>
                                                            <input className="m-2 text-center form-control rounded otp-inputs" onKeyUp={(e) => this.setOTPFieldFocus(e,0) } onKeyPress={(e) => this.validateInput(e)} type="text" id="first" maxlength="1" /> 
                                                            <input className="m-2 text-center form-control rounded otp-inputs" onKeyUp={(e) => this.setOTPFieldFocus(e,1) } onKeyPress={(e) => this.validateInput(e)} type="text" id="second" maxlength="1" /> 
                                                            <input className="m-2 text-center form-control rounded otp-inputs" onKeyUp={(e) => this.setOTPFieldFocus(e,2) } onKeyPress={(e) => this.validateInput(e)} type="text" id="fourth" maxlength="1" /> 
                                                            <input className="m-2 text-center form-control rounded otp-inputs" onKeyUp={(e) => this.setOTPFieldFocus(e,3) } onKeyPress={(e) => this.validateInput(e)} type="text" id="fifth" maxlength="1" /> 
                                                            <input className="m-2 text-center form-control rounded otp-inputs" onKeyUp={(e) => this.setOTPFieldFocus(e,4) } onKeyPress={(e) => this.validateInput(e)} type="text" id="third" maxlength="1" /> 
                                                            <input className="m-2 text-center form-control rounded otp-inputs" onKeyUp={(e) => this.setOTPFieldFocus(e,5) } onKeyPress={(e) => this.validateInput(e)} type="text" id="sixth" maxlength="1" />
                                                        </div> */}
                                                        <p style={{ display: this.state.OTPWarning.length > 0 ? 'block' : 'none', color: 'red' }}>{this.state.OTPWarning}</p>

                                                        <div className="col-md-12" style={{ display:'flex' }}>
                                                            <div className="col-md-6 col-lg-7 col-sm-8 mt-2" style={{ paddingLeft:'10px' }}>
                                                                <div id="timer" className="timerClass" style={{ fontSize:'12px', textAlign:'left', color:'#181818' }}>
                                                                    Resend OTP in {this.state.seconds} sec
                                                                </div>
                                                            </div>
                                                            {
                                                                this.state.resendOTP &&
                                                                    <div className="col-md-6 col-lg-5 col-sm-8 mt-2" style={{ paddingRight:0 }}>
                                                                        <div className="timerClass" style={{ textAlign:'right', fontWeight:'bold', color:'#2F80ED' }}>
                                                                            <span className="resend-btn" style={{ cursor:'pointer' }} onClick={() => this.apiCallToLoginToPortal()}>
                                                                                Resend OTP
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                            }
                                                        </div>

                                                        {
                                                            this.state.sendingOTP ? 
                                                                <Spinner/>
                                                            :
                                                                <div className="col-md-12 login-btn" style={{ textAlign: 'center', display:'flex' }}>
                                                                    <button className="btn submit-login" style={{ width:'100%' }} onClick={() => this.validateOTPLogin()}>Verify & Login</button>
                                                                </div>
                                                        }
                                                        {
                                                            this.state.responseMessage.length > 0 &&
                                                                <div className="responseMessage">
                                                                    <p className="alert alert-danger responseText">
                                                                        {this.state.responseMessage}
                                                                        <FontAwesomeIcon icon={['fas','times']} style={{ marginLeft: 10, cursor: 'pointer' }} onClick={() => this.setState({ responseMessage: '' })}/>
                                                                    </p>
                                                                </div>
                                                        }
                                                    </div>
                                                </div>
                                                <div className="return-login">
                                                    <span onClick={() => this.setState({ OTPVerification: false })} style={{ color: '#212529' }}><p className="return-login-text">Return to Login</p></span>
                                                </div>
                                            </div>
                                        :
                                            <div className="login-form">
                                                <div className="institute-name">
                                                    <div className="instituteLogo-image">
                                                        <img src={instituteLogo} className="instituteLogo-img" />
                                                    </div>
                                                    <div className="instituteName">
                                                        <h6>{ReactHtmlParser(this.state.instituteName)}</h6>
                                                    </div>
                                                </div>
                                                <div className="login-details">
                                                    <div style={{marginBottom: 50 }}>
                                                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: 10 }}>
                                                            <span style={{ color: 'red', marginRight: 5 }}>*</span>
                                                            <input
                                                                type="text"
                                                                placeholder="Username or Email Address"
                                                                className="form-control"
                                                                onChange={(e) => this.getUserName(e)}
                                                            />
                                                        </div>
                                                        <p style={{ display: this.state.userNameWarning.length > 0 ? 'block' : 'none', color: 'red' }}>{this.state.userNameWarning}</p>
                                                    </div>
                                                    <div style={{ marginBottom: 10 }}>
                                                        <div className="show-password-wrapper" style={{ display: 'flex', alignItems: 'center', marginBottom: 10 }}>
                                                            <span style={{ color: 'red', marginRight: 5 }}>*</span>
                                                            <input
                                                                id="passwordValue"
                                                                type="password"
                                                                placeholder="Password"
                                                                className="form-control"
                                                                onKeyPress={(e) => this.getPassword(e)}
                                                                onChange={(e) => this.getPassword(e)}
                                                            />
                                                            <FontAwesomeIcon icon={['fas','eye']} className="view-password" style={{ cursor: 'pointer', marginLeft: 5 }} onMouseOver={() => this.viewPassword()}  onMouseLeave={() => this.hidePassword()}/>
                                                        </div>
                                                        <p style={{ display: this.state.passwordWarning.length > 0 ? 'block' : 'none', color: 'red' }}>{this.state.passwordWarning}</p>
                                                    </div>
                                                    <div className="forgot-password">
                                                        <Link to={`/forgot-password/${this.state.instituteUrl}`} style={{ color: '#212529' }}><p className="forgot-password-text">Forgot Password ?</p></Link>
                                                    </div>
                                                    {
                                                        this.state.sendingOTP ?
                                                            <Spinner/>
                                                        :
                                                            <div className="col-md-12 loginClass" style={{ textAlign: 'center' }}>
                                                                <button className="btn submit-login" style={{ width:'100%' }} onClick={() => this.validateLoginData()}>LogIn</button>
                                                            </div>
                                                    }
                                                    
                                                    <div className='col-md-12' style={{ display: 'flex', alignItems: 'center' }}>
                                                        <hr style={{ width: '46%' }}></hr>
                                                        <span>OR</span>
                                                        <hr style={{ width: '46%' }}></hr>
                                                    </div>
                                                    <GoogleLogin
                                                        clientId={CLIENT_ID}
                                                        buttonText="Log In with Google"
                                                        onSuccess={this.responseGoogleSuccess}
                                                        onFailure={this.responseGoogleError}
                                                        isSignedIn={false}
                                                        cookiePolicy={"single_host_origin"}
                                                        className="googleLoginBtn"
                                                        />
                                                    {
                                                        this.state.responseMessage.length > 0 &&
                                                            <div className="responseMessage">
                                                                <p className="alert alert-danger responseText">
                                                                    {this.state.responseMessage}
                                                                    <FontAwesomeIcon icon={['fas','times']} style={{ marginLeft: 10, cursor: 'pointer' }} onClick={() => this.setState({ responseMessage: '' })}/>
                                                                </p>
                                                            </div>
                                                    }
                                                </div>
                                            </div>
                                }
                                <footer id="sticky-footer" className="big">
                                    <div className="footer-container">
                                        &nbsp; &nbsp;&nbsp; &nbsp;
                                        <a href="https://www.vmedulife.com/privacy-policy" target="_blank" rel="noopener noreferrer" className="footer-link"><span className="footer-data policy">Privacy Policy</span></a>
                                        &nbsp; &nbsp;
                                        <a href="https://www.vmedulife.com/terms-of-service" target="_blank" rel="noopener noreferrer" className="footer-link"><span className="footer-data terms">Terms of Use</span></a>
                                        &nbsp; &nbsp;
                                        <a href="https://www.vmedulife.com/" target="_blank" rel="noopener noreferrer" className="footer-link"><span className="footer-data powered-by">Powered by <span className="vm" style={{marginLeft: "0.2%"}}>vm</span><span className="edu">edu</span><span className="life">life</span></span></a>
                                    </div>
                                </footer>
                            </div>
                            <div className="institute-container col-sm-7 col-md-8 col-lg-8" style={{ backgroundImage: `url(${instituteImage})` }}>
                            </div>
                        </div>
                    :
                        <div className="invalid-url-message">
                            <span className="invalid-message">Invalid URL.</span>
                        </div>
                }
                
            </>
        );
    }
}

export default LoginPage;